import { render, staticRenderFns } from "./SubtitleSection.vue?vue&type=template&id=483cf884&name=title-section&"
import script from "./SubtitleSection.vue?vue&type=script&lang=js&"
export * from "./SubtitleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports